var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('abk-event-form',{attrs:{"event-id":_vm.$route.params.id,"submit-action":_vm.updateEvent,"validate-action":_vm.validate}})}
var staticRenderFns = []

export { render, staticRenderFns }